/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const prefix = (type) => `st/airspaces/${type}`;

export const LIST_LOAD_START = prefix('LIST_LOAD_START');
export const LIST_LOAD_SUCCESS = prefix('LIST_LOAD_SUCCESS');
export const LIST_LOAD_FAILED = prefix('LIST_LOAD_FAILED');

export const AIRSPACE_OVERVIEW_LOAD_START = prefix('AIRSPACE_OVERVIEW_LOAD_START');
export const AIRSPACE_OVERVIEW_LOAD_SUCCESS = prefix('AIRSPACE_OVERVIEW_LOAD_SUCCESS');
export const AIRSPACE_OVERVIEW_LOAD_FAILED = prefix('AIRSPACE_OVERVIEW_LOAD_FAILED');

export const AUDIO_SNIPPETS_LOAD_START = prefix('AUDIO_SNIPPETS_LOAD_START');
export const AUDIO_SNIPPETS_LOAD_SUCCESS = prefix('AUDIO_SNIPPETS_LOAD_SUCCESS');
export const AUDIO_SNIPPETS_LOAD_FAILED = prefix('AUDIO_SNIPPETS_LOAD_FAILED');

export const AUDIO_SNIPPET_URL_LOAD_START = prefix('AUDIO_SNIPPET_URL_LOAD_START');
export const AUDIO_SNIPPET_URL_LOAD_SUCCESS = prefix('AUDIO_SNIPPET_URL_LOAD_SUCCESS');
export const AUDIO_SNIPPET_URL_LOAD_FAILED = prefix('AUDIO_SNIPPET_URL_LOAD_FAILED');

export const AUDIO_SNIPPETS_CLEAR = prefix('AUDIO_SNIPPETS_CLEAR');

export const CLEAR = prefix('CLEAR');
export const CLEAR_AIRSPACE_OVERVIEW = prefix('CLEAR_AIRSPACE_OVERVIEW');
